@if (errors$ | async; as errors) {
  <div>
    @switch (dataType) {
      @case ('array') {
        <div>
          @for (error of $any(errors); track error) {
            <div>
              <span class="text">{{ error | translate }}</span>
            </div>
          }
        </div>
      }
      @case ('object') {
        <div>
          @for (data of $any(errors) | keyvalue; track data) {
            <div>
              <span class="text">
                {{
                  defaultControlErrors[$any(data.key)]
                    ? (defaultControlErrors[$any(data.key)] | translate)
                    : ($any(data.value) | translate)
                }}
              </span>
            </div>
          }
        </div>
      }
    }
  </div>
}
